import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	// GET OPENING BALANCE DETAILS
	getopeningbalanceDetailsFailure,
	getopeningbalanceDetailsResponceChanged,
	getopeningbalanceDetailsSuccess,
	// UPDATE OPENING BALANCE DETAILS
	updateopeningbalanceDetailsFailure,
	updateopeningbalanceDetailsResponceChanged,
	updateopeningbalanceDetailsSuccess,
} from './opening-balance.action';
import OpeningBalanceActionTypes from './opening-balance.types';
import { openingBalanceDetailsGet, openingBalanceDetailsUpdate } from './opening-balance.service';

export function* GetOpeningBalanceDetails({ payload }: any) {
	const { infogCompanyID, branchID, inputSearch, databaseName } = payload;
	try {
		const key = 'OpeningBalanceListKey';
		const jsonData = {
			InfogID: infogCompanyID,
			BranchID: branchID,
			InputSearch: inputSearch,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(openingBalanceDetailsGet, encodeData); // data received
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getopeningbalanceDetailsFailure(responseData.data));
		} else {
			yield put(getopeningbalanceDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getopeningbalanceDetailsFailure(error));
	}
}
export function* resetOpeningBalanceResponse() {
	yield put(getopeningbalanceDetailsResponceChanged());
}

export function* onOpeningBalanceDetails() {
	yield takeLatest(
		OpeningBalanceActionTypes.GET_OPENING_BALANCE_DETAILS_START,
		GetOpeningBalanceDetails,
	);
}

export function* onOpeningBalanceResponseReset() {
	yield takeLatest(
		OpeningBalanceActionTypes.GET_OPENING_BALANCE_DETAILS_RESPONSE_RESET,
		resetOpeningBalanceResponse,
	);
}

/** ***************** UPDATE OPENING BALANCE DETAILS START *********************** */
export function* updateOpeningBalanceDetails({ payload }: any) {
	const { openingBalUpdateArr, branchID, infogCompanyID, databaseName, userID, userName } =
		payload;
	try {
		const key = 'UpdateOpeningBalDetailsKey';
		const jsonData = {
			InfogID: infogCompanyID,
			UserID: userID,
			UserName: userName,
			DatabaseName: databaseName,
			OpeningBalanceAmountArr: openingBalUpdateArr,
			BranchID: branchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(openingBalanceDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateopeningbalanceDetailsFailure(responseData.data));
		} else {
			yield put(updateopeningbalanceDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateopeningbalanceDetailsFailure(error));
	}
}

export function* resetUpdateOpeningBalDetailsResponse() {
	yield put(updateopeningbalanceDetailsResponceChanged());
}

export function* onUpdateOpeningBalDetails() {
	yield takeLatest(
		OpeningBalanceActionTypes.UPDATE_OPENING_BALANCE_DETAILS_START,
		updateOpeningBalanceDetails,
	);
}

export function* onUpdateOpeningBalDetailsResponseReset() {
	yield takeLatest(
		OpeningBalanceActionTypes.UPDATE_OPENING_BALANCE_DETAILS_RESPONSE_RESET,
		resetUpdateOpeningBalDetailsResponse,
	);
}
/** ***************** UPDATE OPENING BALANCE DETAILS END *********************** */

export function* openingbalanceFinanceSaga() {
	yield all([
		// GET OPENING BALANCE DETAILS
		call(onOpeningBalanceDetails),
		call(onOpeningBalanceResponseReset),
		// UPDATE OPENING BALANCE DETAILS
		call(onUpdateOpeningBalDetails),
		call(onUpdateOpeningBalDetailsResponseReset),
	]);
}
